import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { updateCreateGroupData } from "../../../store/Slices/CreateGroupSlice";

export default function GroupDescriptionInput() {
  const dispatch = useAppDispatch();
  const CreateGroup = useAppSelector((state) => state.CreateGroup);

  return (
    <textarea
      placeholder="Group Description"
      value={CreateGroup.group_description}
      onChange={(e) => {
        dispatch(
          updateCreateGroupData({ group_description: e.target.value }),
        );
      }}
      rows={3}
      className="w-full resize-none border-none bg-transparent py-1 text-[15px] text-darkText outline-none placeholder:text-lightText"
    />
  );
}
